"use client";

import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const Map = ({ item }) => {
  // Ensure latitude and longitude are valid numbers
  const lat = Number(item?.latitude);
  const lng = Number(item?.longitude);

  // Check if lat and lng are finite numbers
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return <div>Invalid location data</div>; // Handle invalid location case
  }

  return (
    <LoadScript googleMapsApiKey="AIzaSyB-a3pzYIQjBy5hrP94T38x1qQU0X9OZqg">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={{ lat, lng }}
        zoom={13}
      >
        <Marker position={{ lat, lng }} />
      </GoogleMap>
    </LoadScript>
  );
};

export default Map;
